import { CommonModule } from '@angular/common'
import { ChangeDetectionStrategy, Component, Input, signal } from '@angular/core'
import { PipesModule } from '@core/pipes/pipes.module'
import { PalantirCardComponent, PalantirSkeletonComponent, PalantirTextComponent } from '@fieldcontrol/palantir'
import { Warranty } from '@generated/sammathnaur.graphql'
import { TranslateModule } from '@ngx-translate/core'
import { WarrantyStatusLabelComponent } from '../warranty-status-label/warranty-status-label.component'

@Component({
  selector: 'app-warranty-item',
  templateUrl: './warranty-item.component.html',
  styleUrls: ['./warranty-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    PalantirCardComponent,
    PalantirTextComponent,
    PipesModule,
    WarrantyStatusLabelComponent,
    TranslateModule,
    PalantirSkeletonComponent
  ]
})
export class WarrantyItemComponent {
  @Input({ required: true })
  public warranty!: Warranty

  @Input({ required: true })
  public isLoading?: boolean

  public isHovering = signal<boolean>(false)
}
